"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityClaimExperiences = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
let OpportunityClaimExperiences = class OpportunityClaimExperiences {
    constructor(id, opportunityId, policyFrom, policyTo, natureOfLoss, premium, claimAmount, claimPercentage, remarks) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.policyFrom = policyFrom;
        this.policyTo = policyTo;
        this.natureOfLoss = natureOfLoss;
        this.premium = premium;
        this.claimAmount = claimAmount;
        this.claimPercentage = claimPercentage;
        this.remarks = remarks;
    }
};
exports.OpportunityClaimExperiences = OpportunityClaimExperiences;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityClaimExperiences.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityClaimExperiences.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_from", type: "date" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityClaimExperiences.prototype, "policyFrom", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_to", type: "date" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], OpportunityClaimExperiences.prototype, "policyTo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "nature_of_loss",
        type: "varchar",
        length: 255,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityClaimExperiences.prototype, "natureOfLoss", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "premium", type: "float", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityClaimExperiences.prototype, "premium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "claim_amount", type: "float", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityClaimExperiences.prototype, "claimAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "claim_percentage", type: "float", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityClaimExperiences.prototype, "claimPercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityClaimExperiences.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.opportunityId),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityClaimExperiences.prototype, "opportunity", void 0);
exports.OpportunityClaimExperiences = OpportunityClaimExperiences = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_claim_experience"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, String, Number, Number, Number, String])
], OpportunityClaimExperiences);
